<template>
  <div>
    <terminal-pesagem v-if="terminal === '1'"/>
    <auto-terminal v-if="terminal === '2'"/>
    <kds-gestor v-if="terminal === '3'"/>
    <monitor v-if="terminal === '4'"/>
  </div>
</template>

<script>
import TerminalPesagem from "@/views/terminal/TerminalPesagem";
import AutoTerminal from "@/views/terminal/AutoTerminal";
import KdsGestor from "@/views/terminal/KdsGestor";
import Monitor from "@/views/terminal/Monitor";
export default {
  name: "Terminal",
  components: {Monitor, KdsGestor, AutoTerminal, TerminalPesagem},

  mounted() {
    if (!this.terminal) {
      this.$router.push('/');
    }
  },

  computed: {
    terminal() {
      return this.$store.state.isTerminal || '4';
    }
  }
}
</script>

<style scoped>

</style>